import { render, staticRenderFns } from "./AllAccessTable.vue?vue&type=template&id=0c065878"
import script from "./AllAccessTable.vue?vue&type=script&lang=js"
export * from "./AllAccessTable.vue?vue&type=script&lang=js"
import style0 from "./AllAccessTable.vue?vue&type=style&index=0&id=0c065878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports